"use client"

import type React from "react"
import { useRef, useEffect } from "react"
import { cn } from "@/lib/utils"

interface GoldHeadingProps {
  children: React.ReactNode
  className?: string
}

export function GoldHeading({ children, className }: GoldHeadingProps) {
  const headingRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (headingRef.current && !document.querySelector("#gold-shine-animation")) {
      const style = document.createElement("style")
      style.id = "gold-shine-animation"
      style.textContent = `
        @keyframes goldShine {
          0% { background-position: -100% 0; }
          100% { background-position: 100% 0; }
        }
      `
      document.head.appendChild(style)
    }
  }, [])

  return (
    <div className={cn("inline-block relative", className)}>
      <div
        ref={headingRef}
        className="text-transparent bg-clip-text font-bold text-lg uppercase tracking-wider"
        style={{
          backgroundImage: `
            linear-gradient(
              90deg,
              rgba(173, 128, 60, 0) 0%,
              rgba(255, 215, 0, 0.8) 10%,
              rgba(255, 255, 255, 0.9) 20%,
              rgba(255, 215, 0, 0.8) 30%,
              rgba(173, 128, 60, 0) 40%
            ),
            linear-gradient(
              to right,
              #d4af37,
              #f5e6b3,
              #d4af37
            )
          `,
          backgroundSize: "200% 100%, 100% 100%",
          backgroundRepeat: "no-repeat",
          animation: "goldShine 3s linear infinite",
          WebkitBackgroundClip: "text",
          backgroundClip: "text",
        }}
      >
        {children}
      </div>
    </div>
  )
}